<template>
    <div ref="watermarkRef" class="page-watermark"></div>
</template>
<script>
import dictApi from '@/api/dict'

export default {
    name: 'Watermark',
    props: {
        text: { type: String, default: '' },
        rotate: { type: Number, default: -30 },
        gapX: { type: Number, default: 160 },
        gapY: { type: Number, default: 80 },
        fontSize: { type: Number, default: 14 },
        color: { type: String, default: 'rgba(0,0,0,0.08)' }
    },
    data() {
        return {
            companyName: ''
        }
    },
    async mounted() {
        try {
            const res = await dictApi.getValByCode('Huan Shipping')
            if (res.code === 200 && res.data) {
                this.companyName = res.data
            }
        } catch (e) {
            console.error('加载水印公司名称失败', e)
        }
        this.draw()
        this._onResize = () => this.draw()
        window.addEventListener('resize', this._onResize)
        const parent = this.$el.parentElement
        if (parent && window.ResizeObserver) {
            this._ro = new ResizeObserver(() => this.draw())
            this._ro.observe(parent)
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this._onResize)
        if (this._ro) {
            this._ro.disconnect()
        }
    },
    watch: {
        text() { this.draw() },
        companyName() { this.draw() }
    },
    methods: {
        getTodaySuffix() {
            const now = new Date()
            const m = String(now.getMonth() + 1).padStart(2, '0')
            const d = String(now.getDate()).padStart(2, '0')
            return `${m}-${d}`
        },
        getDefaultText() {
            const u = JSON.parse(localStorage.getItem('userInfo') || '{}')
            const cn = u.userName || ''
            const en = u.enName || ''
            const enWithDate = en ? `${en} ${this.getTodaySuffix()}` : ''
            const userLine = [cn, enWithDate].filter(Boolean).join(' ')
            return [this.companyName, userLine].filter(Boolean).join('\n')
        },
        draw() {
            const el = this.$refs.watermarkRef
            if (!el) return
            const content = this.text || this.getDefaultText()
            if (!content) {
                el.style.backgroundImage = 'none'
                return
            }
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')
            const lines = content.split('\n')
            const lineHeight = this.fontSize + 6
            ctx.font = `${this.fontSize}px sans-serif`
            const textWidth = Math.max(...lines.map(l => ctx.measureText(l).width))
            canvas.width = this.gapX + textWidth
            canvas.height = this.gapY + lines.length * lineHeight
            ctx.translate(canvas.width / 2, canvas.height / 2)
            ctx.rotate((this.rotate * Math.PI) / 180)
            ctx.fillStyle = this.color
            ctx.font = `${this.fontSize}px sans-serif`
            ctx.textAlign = 'center'
            ctx.textBaseline = 'middle'
            lines.forEach((line, i) => {
                const offset = (i - (lines.length - 1) / 2) * lineHeight
                ctx.fillText(line, 0, offset)
            })
            el.style.backgroundImage = `url(${canvas.toDataURL('image/png')})`
            el.style.backgroundRepeat = 'repeat'
            el.style.backgroundSize = `${canvas.width}px ${canvas.height}px`
            this.syncHeight()
        },
        syncHeight() {
            const el = this.$refs.watermarkRef
            const parent = el && el.parentElement
            if (!el || !parent) return
            el.style.height = parent.scrollHeight + 'px'
        },
    }
}
</script>
<style scoped>
.page-watermark {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 5;
    overflow: hidden;
}
</style>
